<script>
import resources from './resources'

export default {
  name: 'covenant',
  mixins: [resources]
}
</script>

<template lang="pug">
  .list-item(:class="{'white-bg' : covenant.active, 'white-bg-disable' : !covenant.active}")
    .row.border-bottom
      h4.col-xs-7  {{ name }}
      .col-xs-5
        .exclude-list(v-if="covenant.active", @click.prevent="$emit('on-delete', covenant)")
          span.icon 
        a(href='')
          //- .edit-list(v-if="!covenant.active", @click.prevent="$emit('on-active', covenant)")
        router-link.edit-list(:to="{name: 'settings.covenants.edit', params: {id: covenant.id}}")
          span.icon 
    .list-info
      .condition {{ covenant.covenant.name }}
      .plano {{ plan_name }}
      i.fa.fa-credit-card(aria-hidden="true", v-tooltip="'Número do Cartão do Beneficiário'") &nbsp;
      span
          strong(v-if="covenant.card_number") {{ covenant.card_number }}
      span
          strong(v-if="!covenant.card_number") Cartão não informado
</template>



// WEBPACK FOOTER //
// src/app/settings/covenants/index/components/covenant.vue